import React from 'react';

const ProgTableroProg2 = props => {
  let resolucionPantalla = {
    ancho: window.screen.width,
    alto: window.screen.height
  };
  
  let ancho=resolucionPantalla.ancho*0.95
  let alto=resolucionPantalla.alto*0.95
  return (
    <div>
      <iframe width={ancho} height={alto} src="https://lookerstudio.google.com/embed/reporting/a46b04d1-6cd1-48a7-83bb-fdfd026ac47c/page/sIgGD"></iframe>
    </div>
  )
}

export default ProgTableroProg2